import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import InputAdornment from '@mui/material/InputAdornment';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FilledInput from '@mui/material/FilledInput';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Divider from '@mui/material/Divider';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'engNm', label: '제품명(영문)', minWidth: 140, align: 'center' },
  { id: 'korNm', label: '제품명(한글)', minWidth: 100, align: 'center' },
  { id: 'ver', label: '버전', minWidth: 180, align: 'center' }
];

const extensionColumns = [{ id: 'extension', label: '확장자', minWidth: 140, align: 'center' }];

export default function PgmMng() {
  const [srchData, setSrchData] = useState({});
  const [datas, setDatas] = useState({ viewYn: false, kind: 'public' });
  const [rows, setRows] = useState([]);
  const [extensionRows, setExtensionRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [open, setOpen] = useState(false);
  const [extension, setExtension] = useState('');

  const thumbnailImgInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const manualInputRef = useRef(null);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const { ref: thumbnailImgRef, onChange: onThumbnailImgChange, ...thumbnailImgRest } = register('datas.thumbnailImg');
  const { ref: fileRef, onChange: onFileChange, ...fileRest } = register('datas.file');
  const { ref: manualRef, onChange: onManualChange, ...manualRest } = register('datas.manual');

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleChangeExtension = (e) => {
    setExtension(e.target.value);
  };

  const handleChangeImgInput = (e) => {
    setDatas({ ...datas, thumbnailImgNameOrigin: e.target.files.item(0).name });
    setValue(null, null, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeFileInput = (e) => {
    setDatas({ ...datas, fileNameOrigin: e.target.files.item(0).name });
    setValue(null, null, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeManualInput = (e) => {
    setDatas({ ...datas, manualNameOrigin: e.target.files.item(0).name });
    setValue(null, null, { shouldValidate: true, shouldDirty: true });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeViewYn = (e) => {
    setValue('datas.viewYn', e.target.value);
    setDatas({ ...datas, viewYn: e.target.value });
  };

  const handleChangeKind = (e) => {
    setValue('datas.kind', e.target.value);
    setDatas({ ...datas, kind: e.target.value });
  };

  const getDataList = async (e) => {
    const { pgmNm } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      pgmNm
    };

    const response = await axios.get(`/api/pgm`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const onClickExtensionSave = async (evt) => {
    if (datas.id && extension) {
      const params = { extension, name: datas.engNm };
      await axios
        .post(`/api/didas/extension`, params)
        .then(async (response) => {
          alert(response.data.message);
          await getExtensionList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const onClickExtensionDelete = async (row) => {
    if (window.confirm('확장자를 삭제하시겠습니까?')) {
      await axios
        .delete(`/api/didas/extension`, { params: row })
        .then(async (response) => {
          alert(response.data.message);
          await getExtensionList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getExtensionList = async (e) => {
    await setExtension();
    await setExtensionRows([]);
    await axios.get(`/api/didas/extension/${datas.engNm}`).then((response) => {
      if (response.data.extList) {
        setExtensionRows(response.data.extList);
      }
    });
  };

  const initForm = () => {
    setDatas({ viewYn: false, kind: 'public' });
    clearErrors();
    reset();
  };

  const pgmMngCreate = async (data) => {
    let formData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };

    formData.append('engNm', data.engNm);
    formData.append('korNm', data.korNm);
    formData.append('ver', data.ver);
    formData.append('thumbnailImg', thumbnailImgInputRef.current.files[0]);
    formData.append('file', fileInputRef.current.files[0]);
    formData.append('manual', manualInputRef.current.files[0]);
    formData.append('mediaUrl', data.mediaUrl);
    formData.append('viewYn', datas.viewYn);
    formData.append('kind', datas.kind);

    return await axios.post(`/api/pgm`, formData, config);
  };

  const pgmMngUpdate = async (data) => {
    let formData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };

    console.log(data);
    formData.append('engNm', data.engNm);
    formData.append('korNm', data.korNm);
    formData.append('ver', data.ver);
    formData.append('thumbnailImg', thumbnailImgInputRef.current.files[0]);
    formData.append('file', fileInputRef.current.files[0]);
    formData.append('manual', manualInputRef.current.files[0]);
    formData.append('mediaUrl', data.mediaUrl);
    formData.append('viewYn', datas.viewYn);
    formData.append('kind', datas.kind);

    for (var pair of formData.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }

    return await axios.patch(`/api/pgm/${data.id}`, formData, config);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .delete(`/api/pgm/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onClickImgUpload = (evt) => {
    if (!!evt.target.id) {
      thumbnailImgInputRef.current.click();
    }
  };

  const onClickImgDelete = (evt) => {
    thumbnailImgInputRef.current.value = '';
    setDatas({ ...datas, thumbnailImgNameOrigin: '' });
  };

  const onClickFileUpload = async (evt) => {
    if (!!evt.target.id) {
      fileInputRef.current.click();
    }
  };

  const onClickFileDelete = (evt) => {
    fileInputRef.current.value = '';
    setDatas({ ...datas, fileNameOrigin: '' });
  };

  const onClickManualUpload = async (evt) => {
    if (!!evt.target.id) {
      manualInputRef.current.click();
    }
  };

  const onClickManualDelete = (evt) => {
    manualInputRef.current.value = '';
    setDatas({ ...datas, manualNameOrigin: '' });
  };

  const createOrUpdate = async (datas) => {
    if (!!datas.id) {
      return await pgmMngUpdate(datas);
    } else {
      return await pgmMngCreate(datas);
    }
  };

  const onSubmit = (data) => {
    if (isDirty) {
      setOpen(true);
      createOrUpdate(data.datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
          setOpen(false);
        })
        .catch((error) => {
          alert(error.response.data.message);
          setOpen(false);
        });
    }
  };

  useEffect(async () => {
    if (datas.id) {
      getExtensionList();
    }
  }, [datas.id]);

  useEffect(() => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        제품 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Stack direction="row" spacing={2}>
            <TextField id="pgmNmSrch" variant="outlined" size="small" label="제품명" value={srchData?.pgmNm || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        {row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="pgmMngForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              {!!datas.id ? '수정' : '등록'}
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas.id ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="pgmMngForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              name="engNm"
              label="제품명(영문)"
              id="engNm"
              value={datas?.engNm || ''}
              error={!!errors.datas?.engNm}
              helperText={errors.datas?.engNm && errors.datas?.engNm.message}
              {...register('datas.engNm', {
                required: '회사명을 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="korNm"
              label="제품명(한글)"
              id="korNm"
              value={datas?.korNm || ''}
              error={!!errors.datas?.korNm}
              helperText={errors.datas?.korNm && errors.datas?.korNm.message}
              {...register('datas.korNm', {
                required: '회사명을 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              fullWidth
              name="ver"
              label="버전"
              id="ver"
              value={datas?.ver || ''}
              error={!!errors.datas?.ver}
              helperText={errors.datas?.ver && errors.datas?.ver.message}
              {...register('datas.ver', { onChange: (e) => handleChange(e) })}
            />
            <Divider />
            <input
              type="file"
              style={{ display: 'none' }}
              onChange={handleChangeImgInput}
              id="thumbnailImg"
              name="thumbnailImg"
              ref={(e) => {
                thumbnailImgRef(e);
                thumbnailImgInputRef.current = e; // you can still assign to ref
              }}
              onChange={(e) => {
                handleChangeImgInput(e);
              }}
              {...thumbnailImgRest}
            />
            <FormControl fullWidth variant="filled" margin="dense" size="small">
              <InputLabel htmlFor="thumbnailImgInput">썸네일</InputLabel>
              <FilledInput
                id="thumbnailImgInput"
                size="small"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={onClickImgDelete}>
                      {datas?.thumbnailImgNameOrigin && <HighlightOffIcon />}
                    </IconButton>
                  </InputAdornment>
                }
                fullWidth
                label="썸네일"
                variant="standard"
                margin="dense"
                inputProps={{ readOnly: true }}
                value={datas?.thumbnailImgNameOrigin || ''}
                onClick={onClickImgUpload}
                {...register('datas.thumbnailImgNameOrigin')}
              />
            </FormControl>
            <Button id="thumbnailImgUploadButton" margin="dense" variant="contained" fullWidth onClick={onClickImgUpload}>
              썸네일 업로드
            </Button>
            <input
              type="file"
              style={{ display: 'none' }}
              ref={(e) => {
                fileRef(e);
                fileInputRef.current = e; // you can still assign to ref
              }}
              onChange={(e) => {
                handleChangeFileInput(e);
              }}
              {...fileRest}
            />
            <FormControl fullWidth variant="filled" margin="dense" size="small">
              <InputLabel htmlFor="fileInput">파일</InputLabel>
              <FilledInput
                id="fileInput"
                size="small"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={onClickFileDelete}>
                      {datas?.fileNameOrigin && <HighlightOffIcon />}
                    </IconButton>
                  </InputAdornment>
                }
                fullWidth
                variant="standard"
                margin="dense"
                inputProps={{ readOnly: true }}
                value={datas?.fileNameOrigin || ''}
                onClick={onClickFileUpload}
                {...register('datas.fileNameOrigin')}
              />
            </FormControl>
            <Button id="fileUploadButton" margin="dense" variant="contained" fullWidth onClick={onClickFileUpload}>
              파일 업로드
            </Button>
            <input
              type="file"
              style={{ display: 'none' }}
              ref={(e) => {
                manualRef(e);
                manualInputRef.current = e; // you can still assign to ref
              }}
              onChange={(e) => {
                handleChangeManualInput(e);
              }}
              {...manualRest}
            />
            <FormControl fullWidth variant="filled" margin="dense" size="small">
              <InputLabel htmlFor="manualInput">메뉴얼</InputLabel>
              <FilledInput
                id="manualInput"
                size="small"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={onClickManualDelete}>
                      {datas?.manualNameOrigin && <HighlightOffIcon />}
                    </IconButton>
                  </InputAdornment>
                }
                fullWidth
                variant="standard"
                margin="dense"
                inputProps={{ readOnly: true }}
                value={datas?.manualNameOrigin || ''}
                onClick={onClickManualUpload}
                {...register('datas.manualNameOrigin')}
              />
            </FormControl>
            <Button id="manualUploadButton" margin="dense" variant="contained" fullWidth onClick={onClickManualUpload}>
              메뉴얼 업로드
            </Button>
            <TextField
              margin="dense"
              fullWidth
              name="mediaUrl"
              label="영상 URL"
              id="mediaUrl"
              value={datas?.mediaUrl || ''}
              error={!!errors.datas?.mediaUrl}
              helperText={errors.datas?.mediaUrl && errors.datas?.mediaUrl.message}
              {...register('datas.mediaUrl', { onChange: (e) => handleChange(e) })}
            />
            <Typography variant="body2" color="red">
              ※ embed 주소로 입력 해주세요.
            </Typography>
            <Divider sx={{ mt: 2, mb: 1 }} />
            <FormControl>
              <FormLabel required>분류</FormLabel>
              <RadioGroup name="kind" id="kind" value={datas.kind} onChange={handleChangeKind}>
                <FormControlLabel key="public" value={'public'} control={<Radio {...register('datas.kind')} />} label="공개용" />
                <FormControlLabel key="didas" value={'didas'} control={<Radio {...register('datas.kind')} />} label="DIDAS" />
              </RadioGroup>
            </FormControl>
            <br />
            <FormControl>
              <FormLabel required>표시 여부</FormLabel>
              <RadioGroup name="viewYn" id="viewYn" value={datas.viewYn} onChange={handleChangeViewYn}>
                <FormControlLabel key="true" value={true} control={<Radio {...register('datas.viewYn')} />} label="표시" />
                <FormControlLabel key="false" value={false} control={<Radio {...register('datas.viewYn')} />} label="미표시" />
              </RadioGroup>
            </FormControl>
            <Divider sx={{ mt: 2, mb: 1 }} />
            <FormLabel>확장자</FormLabel>
            <br />
            <TextField
              size="small"
              margin="dense"
              name="extension"
              label="확장자"
              id="extension"
              value={extension || ''}
              error={!!errors.extension}
              helperText={errors.extension && errors.extension.message}
              {...register('extension', { onChange: (e) => handleChangeExtension(e) })}
            />
            <Button variant="contained" onClick={onClickExtensionSave} sx={{ mt: '8px', ml: 1 }}>
              확장자 등록
            </Button>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {extensionColumns.map((column) => (
                      <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {extensionRows.map((row, rowIdx) => (
                    <TableRow hover key={row.id + 'ext'} onClick={() => onClickExtensionDelete(row)}>
                      {extensionColumns.map((col, colIdx) => (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {row[col.id]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Backdrop open={open}>
            <CircularProgress />
          </Backdrop>
        </Grid>
      </Grid>
    </Paper>
  );
}
